export const linkTheme = {
    baseStyle: {
        textDecoration: 'underline',
    },
};
